if (typeof DynaCore_Field == 'undefined') {
    $(document).ready(function () {
        DynaCore_Field.init();
    });

    var DynaCore_Field =
    {
        /**
         * Inicializace
         */
        init: function () {
            DynaCore_Field.linkInit();
            DynaCore_Field.relationInit();
            DynaCore_Field.typeInit();
            DynaCore_Field_Filter.init();
        },

        /**
         * Inicializace pole typu Link
         */
        linkInit: function () {
            var target = DynaBase_Url.getPart(0);
            var targetAlias = DynaBase_Url.getPart(1);

            // Text
            $("#linkDynamicTextPattern").off('input');
            $("#linkDynamicTextPattern").on('input', function (e) {
                var countPattern = (this.value.match(/%s/g) || []).length;
                var countFields = $('.linkDynamicTextField').length;
                var countDiff = (countPattern - countFields);

                if (countPattern > countFields) {
                    for (i = 1; i <= countDiff; i++) {
                        DynaCore_Field.patternCreateField('linkDynamicTextField', 'linkDynamicTextPattern', target, null, targetAlias);
                    }
                }
                if (countPattern < countFields) {
                    DynaCore_Field.patternRemoveField('linkDynamicTextField');
                }

                // Zadne hodnoty v paternu, vymazeme vsechna pole
                if (0 == countPattern) {
                    DynaCore_Field.patternRemoveFields('linkDynamicTextField');
                }
            });

            // Uri
            $("#linkDynamicUriPattern").off('input');
            $("#linkDynamicUriPattern").on('input', function (e) {
                var countPattern = (this.value.match(/%s/g) || []).length;
                var countFields = $('.linkDynamicUriField').length;
                var countDiff = (countPattern - countFields);

                if (countPattern > countFields) {
                    for (i = 1; i <= countDiff; i++) {
                        DynaCore_Field.patternCreateField('linkDynamicUriField', 'linkDynamicUriPattern', target, null, targetAlias);
                    }
                }
                if (countPattern < countFields) {
                    DynaCore_Field.patternRemoveField('linkDynamicUriField');
                }

                // Zadne hodnoty v paternu, vymazeme vsechna pole
                if (0 == countPattern) {
                    DynaCore_Field.patternRemoveFields('linkDynamicUriField');
                }
            });
        },

        /**
         * Nacteni poli do elementu
         */
        loadToElement: function (element, target, targetId, targetAlias) {
            $.ajax({
                type: 'get',
                url: '/core/field/load-fields',
                data: {ta: target, taId: targetId, taAl: targetAlias},
                dataType: 'json',
                beforeSend: function () {
                    $(element).prop('disabled', true).attr('disabled', true);
                },
                complete: function () {
                    $(element).prop('disabled', false).attr('disabled', false).focus();
                },
                success: function (data) {

                    // Remove existing options
                    $(element).find('option').remove();

                    // Append new options
                    $.each(data, function (i, item) {
                        $(element).append($('<option value="' + item.i + '">' + item.n + '</option>'));
                    });
                }
            });
        },

        filtersToggle: function()
        {
            // Relation - External
            if ($('.relationField:first').val() > 0) {
                $('#block-filters').removeClass('d-none');
            } else {
                $('#block-filters').addClass('d-none');
                $('#block-filters').find('tbody').html('');
            }
        },

        /**
         * Pridani pole relace na sekci
         */
        patternCreateField: function (prefix, fieldId, target, targetId, targetAlias) {
            var span = $('#form-template-' + prefix + 's');
            var template = $(span).attr('data-template');
            var count = $('.' + prefix).length;

            template = template.replace(/__index__/g, count);

            if (count == 0) {
                $.ajax({
                    type: 'get',
                    url: '/core/field/load-fields',
                    data: {ta: target, taId: targetId, taAl: targetAlias},
                    dataType: 'json',
                    beforeSend: function () {
                        $("#" + fieldId).prop('disabled', true).attr('disabled', true);
                    },
                    complete: function () {
                        $("#" + fieldId).prop('disabled', false).attr('disabled', false).focus();
                    },
                    success: function (data) {

                        // Parse HTML
                        template = $.parseHTML(template);

                        // Remove existing options
                        $(template).find('option').remove();

                        // Append new options
                        $.each(data, function (i, item) {
                            $(template).find('select').append($('<option value="' + item.i + '">' + item.n + '</option>'));
                        });

                        template = $(template)[0].outerHTML;

                        $(span).before(template);
                    }
                });
            } else {
                var options = $('.' + prefix).first().html();

                $(span).before(template);
                $('.' + prefix).last().html(options).prop('selectedIndex', 0);
            }
        },

        /**
         * Smazani pole relace na sekci
         */
        patternRemoveField: function (prefix) {
            $('.' + prefix).last().parents('.form-group').remove();
        },

        /**
         * Odstrani vsechny pole patternu
         */
        patternRemoveFields: function (prefix) {
            $('.' + prefix).parents('.form-group').remove();
        },

        /**
         * Smazani nevyplnenych poli relace na hodnotu
         */
        patternRemoveFieldsEmpty: function (prefix) {
            setTimeout(function () {
                var countFocus = $('.' + prefix + ':focus').length;
                if (countFocus == 0) {
                    var relationValuesValue = $('.' + prefix).not(':first').filter(function () {
                        return this.value == "";
                    }).parents('.form-group');

                    $(relationValuesValue).remove();
                }
            }, 50);
        },

        /**
         * Inicializace pole typu Relation
         */
        relationInit: function () {
            // Zrusime puvodni udalosti
            $("#relationList").off('change');
            $("#relationPattern").off('input');
            $("#relationSection").off('change');
            $("#relationTarget").off('change');

            // Zaregistrujeme nove udalosti
            $("#relationList").on('change', function () {
                DynaCore_Field.filtersToggle();
                DynaCore_Field.relationListChanged(this);
            });
            $("#relationPattern").on('input', function (e) {
                var countPattern = (this.value.match(/%s/g) || []).length;
                var relationTarget = $('#relationTarget').val();

                if ('list' == relationTarget || $('#relationTarget').length == 0) {
                    var relationTargetId = $('#relationList').val();
                }
                if ('miniform' == relationTarget) {
                    var relationTargetId = $('#relationMiniform').val();
                }
                if ('section' == relationTarget) {
                    var relationTargetId = $('#relationSection').val();
                }

                var countFields = $('.relationField').length;
                var countDiff = (countPattern - countFields);

                if (countPattern > countFields) {
                    for (i = 1; i <= countDiff; i++) {
                        DynaCore_Field.patternCreateField('relationField', 'relationPattern', relationTarget, relationTargetId);
                    }
                }
                if (countPattern < countFields) {
                    DynaCore_Field.patternRemoveField('relationField');
                }

                // Zadne hodnoty v paternu, vymazeme vsechna pole
                if (0 == countPattern) {
                    DynaCore_Field.patternRemoveFields('relationField');
                }
            });
            $("#relationSection").on('change', function () {
                DynaCore_Field.filtersToggle();
                DynaCore_Field.relationSectionChanged(this);
            });
            $("#relationTarget").on('change', function () {
                DynaCore_Field.filtersToggle();
                DynaCore_Field.typeRelationTargetChanged(this.value);
            });
            $("form").on('change', '.relationField', function (e) {
                DynaCore_Field.filtersToggle();
            });
        },

        /**
         * Zmena relace na ciselnik
         *
         * @param element
         */
        relationListChanged: function (element) {
            $('#relationPattern').val('');
            DynaCore_Field.patternRemoveFields('relationField');

            if ($(element).val() > 0) {
                $('#form-group-relationPattern').removeClass('d-none');
            } else {
                $('#form-group-relationPattern').addClass('d-none');
            }
        },

        /**
         * Zmena relace na sekci
         *
         * @param element
         */
        relationSectionChanged: function (element) {
            $('#relationPattern').val('');
            DynaCore_Field.patternRemoveFields('relationField');

            if ($(element).val() > 0) {
                $('#form-group-relationPattern').removeClass('d-none');
            } else {
                $('#form-group-relationPattern').addClass('d-none');
            }
        },

        /**
         * Inicializace zmeny typu pole
         */
        typeInit: function () {
            $('#dateDefaultStatic').datetimepicker({format: 'D.M.YYYY', locale: 'cs', showTodayButton: true});
            $('#dateMinStatic').datetimepicker({format: 'D.M.YYYY', locale: 'cs', showTodayButton: true});
            $('#dateMaxStatic').datetimepicker({format: 'D.M.YYYY', locale: 'cs', showTodayButton: true});

            // Zrusime puvodni udalosti
            $("#type").off('change');
            $("#linkType").off('change');
            $("#relationExternal").off('change');
            $(".dateDefaultType").off('change');
            $(".dateMinType").off('change');
            $(".dateMaxType").off('change');

            // Zaregistrujeme nove udalosti
            $("#type").on('change', function () {
                DynaCore_Field.typeChanged();
            });
            $("#linkType").on('change', function () {
                DynaCore_Field.typeLinkChanged(this.value);
            });
            $("#relationExternal").on('change', function () {
                if ($('#relationTarget').length == 0) {
                    DynaCore_Field.typeRelationTargetChanged('list');
                } else {
                    DynaCore_Field.typeRelationExternalChanged(this.value);
                }
            });
            $(".dateDefaultType").on('change', function () {
                DynaCore_Field.typeDateChanged('Default');
            });
            $(".dateMinType").on('change', function () {
                DynaCore_Field.typeDateChanged('Min');
            });
            $(".dateMaxType").on('change', function () {
                DynaCore_Field.typeDateChanged('Max');
            });
        },

        /**
         * Zmena typu sekce
         */
        typeChanged: function () {
            DynaCore_Field.filtersToggle();
            DynaCore_Field.patternRemoveFields('linkDynamicTextField');
            DynaCore_Field.patternRemoveFields('linkDynamicUriField');
            DynaCore_Field.patternRemoveFields('relationField');

            var value = $('#type').val();

            // Skryti pole
            $('#form-group-bankaccountDefault').addClass('d-none');
            $('#form-group-checkboxDefault').addClass('d-none');
            $('#form-group-currencyCode').addClass('d-none');
            $('#form-group-currencyDefault').addClass('d-none');
            $('#form-group-currencyMin').addClass('d-none');
            $('#form-group-currencyMax').addClass('d-none');
            $('#form-group-currencyVisibleDecimalPlaces').addClass('d-none');
            $('#form-group-dateDefaultType').addClass('d-none');
            $('#form-group-dateDefaultStatic').addClass('d-none');
            $('#form-group-dateDefaultDynamic').addClass('d-none');
            $('#form-group-dateMaxType').addClass('d-none');
            $('#form-group-dateMaxStatic').addClass('d-none');
            $('#form-group-dateMaxDynamic').addClass('d-none');
            $('#form-group-dateMinType').addClass('d-none');
            $('#form-group-dateMinStatic').addClass('d-none');
            $('#form-group-dateMinDynamic').addClass('d-none');
            $('#form-group-decimalDefault').addClass('d-none');
            $('#form-group-decimalLengthBeforeDecimalPoint').addClass('d-none');
            $('#form-group-decimalLengthAfterDecimalPoint').addClass('d-none');
            $('#form-group-decimalVisibleDecimalPlaces').addClass('d-none');
            $('#form-group-decimalMin').addClass('d-none');
            $('#form-group-decimalMax').addClass('d-none');
            $('#form-group-emailDefault').addClass('d-none');
            $('#form-group-fileMultiple').addClass('d-none');
            $('#form-group-fileShowExtension').addClass('d-none');
            $('#form-group-fileShowSize').addClass('d-none');
            $('#form-group-hiddenDefault').addClass('d-none');
            $('#form-group-ipDefault').addClass('d-none');
            $('#form-group-isReadonly').addClass('d-none');
            $('#form-group-lengthMax').addClass('d-none');
            $('#form-group-lengthMin').addClass('d-none');
            $('#form-group-linkType').addClass('d-none');
            $('#form-group-linkStaticDefault').addClass('d-none');
            $('#form-group-linkStaticText').addClass('d-none');
            $('#form-group-linkDynamicTextPattern').addClass('d-none');
            $('#form-group-linkDynamicUriPattern').addClass('d-none');
            $('#form-group-multiselectRows').addClass('d-none');
            $('#form-group-numberDefault').addClass('d-none');
            $('#form-group-numberDivisor').addClass('d-none');
            $('#form-group-numberDoNotFormat').addClass('d-none');
            $('#form-group-numberMax').addClass('d-none');
            $('#form-group-numberMin').addClass('d-none');
            $('#form-group-numberMultiplier').addClass('d-none');
            $('#form-group-passwordDefault').addClass('d-none');
            $('#form-group-relationExternal').addClass('d-none');
            $('#form-group-relationPattern').addClass('d-none');
            $('#form-group-relationList').addClass('d-none');
            $('#form-group-relationMiniform').addClass('d-none');
            $('#form-group-relationSection').addClass('d-none');
            $('#form-group-relationShowButtonAdd').addClass('d-none');
            $('#form-group-relationShowButtonDetail').addClass('d-none');
            $('#form-group-relationShowButtonEdit').addClass('d-none');
            $('#form-group-relationTarget').addClass('d-none');
            $('#form-group-telephoneDefault').addClass('d-none');
            $('#form-group-textDefault').addClass('d-none');
            $('#form-group-textareaDefault').addClass('d-none');
            $('#form-group-textareaRows').addClass('d-none');
            $('#form-group-timeDefault').addClass('d-none');
            $('#form-group-timeUseSeconds').addClass('d-none');
            $('#form-group-timeMin').addClass('d-none');
            $('#form-group-timeMax').addClass('d-none');

            // Reset hodnot
            $('#bankaccountDefault').val('');
            $('#checkboxDefault').val(0);
            $('#currencyCode').val('');
            $('#currencyDefault').val('');
            $('#currencyMax').val('');
            $('#currencyMin').val('');
            $('#currencyVisibleDecimalPlaces').val('');
            $('#dateDefaultType').val('');
            $('#dateDefaultStatic').val('');
            $('#dateDefaultDynamic').val('');
            $('#dateMaxType').val('');
            $('#dateMaxStatic').val('');
            $('#dateMaxDynamic').val('');
            $('#dateMinType').val('');
            $('#dateMinStatic').val('');
            $('#dateMinDynamic').val('');
            $('#decimalDefault').val('');
            $('#decimalLengthBeforeDecimalPoint').val('');
            $('#decimalLengthAfterDecimalPoint').val('');
            $('#decimalVisibleDecimalPlaces').val('');
            $('#decimalMax').val('');
            $('#decimalMin').val('');
            $('#emailDefault').val('');
            $('#fileMultiple').prop('checked', false).attr('checked', false);
            $('#fileShowExtension').prop('checked', false).attr('checked', false);
            $('#fileShowSize').prop('checked', false).attr('checked', false);
            $('#hiddenDefault').val('');
            $('#ipDefault').val('');
            $('#lengthMax').val('');
            $('#lengthMin').val('');
            $('#linkType').val('');
            $('#linkStaticDefault').val('');
            $('#linkStaticText').val('');
            $('#linkDynamicTextPattern').val('');
            $('#linkDynamicUriPattern').val('');
            $('#multiselectRows').val('');
            $('#numberDefault').val('');
            $('#numberDivisor').val('');
            $('#numberDoNotFormat').prop('checked', false).attr('checked', false);
            $('#numberMax').val('');
            $('#numberMin').val('');
            $('#numberMultiplier').val('');
            $('#passwordDefault').val('');
            $('#relationExternal').val('');
            $('#relationPattern').val('');
            $('#relationList').val('');
            $('#relationMiniform').val('');
            $('#relationSection').val('');
            $('#relationShowButtonAdd').prop('checked', false).attr('checked', false);
            $('#relationShowButtonDetail').prop('checked', true).attr('checked', true);
            $('#relationShowButtonEdit').prop('checked', false).attr('checked', false);
            $('#relationTarget').val('');
            $('#telephoneDefaultCallingCode').val('');
            $('#telephoneDefaultNumber').val('');
            $('#textDefault').val('');
            $('#textareaDefault').val('');
            $('#textareaRows').val('');
            $('#timeDefault').val('');
            $('#timeUseSeconds').prop('checked', false).attr('checked', false);
            $('#timeMin').val('');
            $('#timeMax').val('');

            // Reset hodnot v selectech
            $('#relationExternal').find('option[value="fromFields"]').remove();
            $('#relationTarget').find('option[value="miniform"]').remove();

            // Text, Number, Password
            if (1 == value || 2 == value || 6 == value || 9 == value || 16 == value) {
                $('#form-group-lengthMin, #form-group-lengthMax').removeClass('d-none');
            }

            // Relation - External
            if (17 == value || 18 == value || 19 == value || 20 == value || 22 == value) {
                $('#form-group-relationExternal').removeClass('d-none');
            }

            // Relation - Show button
            if (17 == value || 22 == value) {
                $('#form-group-relationShowButtonAdd').removeClass('d-none');
                $('#form-group-relationShowButtonDetail').removeClass('d-none');
                $('#form-group-relationShowButtonEdit').removeClass('d-none');
            }

            // Bank account
            if (7 == value) {
                $('#form-group-bankaccountDefault').removeClass('d-none');
            }

            // Checkbox
            if (3 == value) {
                $('#form-group-checkboxDefault').removeClass('d-none');
            }

            // Concat
            if (23 == value) {
                if ('list' === $('#target').val()) {
                    $('#relationList').val($('#targetId').val());
                }
                if ('miniform' === $('#target').val()) {
                    $('#relationTarget').append('<option value="miniform"></option>').val('miniform');
                    $('#relationMiniform').val($('#targetId').val());
                }
                if ('section' === $('#target').val()) {
                    $('#relationSection').val($('#targetId').val());
                }
                $('#relationExternal').append('<option value="fromFields"></option>').val('fromFields');
                $('#relationTarget').val($('#target').val());

                $('#form-group-relationPattern').removeClass('d-none');
            }

            // Currency
            if (16 == value) {
                $('#form-group-currencyCode, #form-group-currencyDefault, #form-group-currencyVisibleDecimalPlaces, #form-group-currencyMin, #form-group-currencyMax').removeClass('d-none');
            }

            // Date
            if (5 == value) {
                var d = new Date();

                $('#form-group-dateDefaultType, #form-group-dateMinType, #form-group-dateMaxType').removeClass('d-none');

                DynaCore_Field.typeDateChanged('Default');
                DynaCore_Field.typeDateChanged('Min');
                DynaCore_Field.typeDateChanged('Max');
            }

            // Decimal
            if (10 == value) {
                $('#form-group-decimalDefault, #form-group-decimalLengthBeforeDecimalPoint, #form-group-decimalLengthAfterDecimalPoint, #form-group-decimalVisibleDecimalPlaces, #form-group-decimalMin, #form-group-decimalMax').removeClass('d-none');
            }

            // Email
            if (13 == value) {
                $('#form-group-emailDefault').removeClass('d-none');
            }

            // FILE
            if (21 == value) {
                $('#form-group-fileMultiple, #form-group-fileShowExtension, #form-group-fileShowSize').removeClass('d-none');
                $('#fileShowExtension').prop('checked', true).attr('checked', true);
            }

            // Hidden
            if (12 == value) {
                $('#form-group-hiddenDefault').removeClass('d-none');
            }

            // Ip
            if (14 == value) {
                $('#form-group-ipDefault').removeClass('d-none');
            }

            // Autocomplete / MultiSelect / MultiRadio / Radio/ Select
            if (17 != value && 18 != value && 19 != value && 20 != value && 22 != value && 23 != value) {
                $('#form-group-isReadonly').removeClass('d-none');
            }

            // Link
            if (8 == value) {
                $('#form-group-linkType').removeClass('d-none');
            }

            // Multiselect
            if (19 == value) {
                $('#form-group-multiselectRows').removeClass('d-none');
            }

            // Number
            if (6 == value) {
                $('#form-group-numberDefault, #form-group-numberMultiplier, #form-group-numberDivisor, #form-group-numberMin, #form-group-numberMax, #form-group-numberDoNotFormat').removeClass('d-none');
            }

            // Numer text
            if (24 == value) {
                $('#form-group-lengthMin, #form-group-lengthMax').removeClass('d-none');
            }

            // Password
            if (9 == value) {
                $('#form-group-passwordDefault').removeClass('d-none');
            }

            // Telephone
            if (15 == value) {
                $('#form-group-telephoneDefault').removeClass('d-none');
            }

            // Text
            if (1 == value) {
                $('#form-group-textDefault').removeClass('d-none');
            }

            // Textarea
            if (2 == value) {
                $('#form-group-textareaDefault, #form-group-textareaRows').removeClass('d-none');
            }

            // Time
            if (11 == value) {
                $('#form-group-timeDefault, #form-group-timeUseSeconds, #form-group-timeMin, #form-group-timeMax').removeClass('d-none');
            }

            // Blok - Validatory
            if (1 == value || 2 == value || 5 == value || 6 == value || 9 == value || 10 == value || 16 == value || 24 == value) {
                $('#blok-validators').removeClass('d-none');
            } else {
                $('#blok-validators').addClass('d-none');
            }
        },

        /**
         * Zmena typu pole u typu Date
         *
         * @param type
         */
        typeDateChanged: function (type) {
            var val = $('#date' + type + 'Type').val();

            if (val == '') {
                $('#form-group-date' + type + 'Static').addClass('d-none');
                $('#form-group-date' + type + 'Dynamic').addClass('d-none');
                $('#date' + type + 'Static').val('');
                $('#date' + type + 'Dynamic_value').val('');
            } else {
                if (val == 'static') {
                    $('#form-group-date' + type + 'Static').removeClass('d-none');
                    $('#form-group-date' + type + 'Dynamic').addClass('d-none');
                    $('#date' + type + 'Dynamic_value').val('');
                }
                if (val == 'dynamic') {
                    $('#form-group-date' + type + 'Static').addClass('d-none');
                    $('#form-group-date' + type + 'Dynamic').removeClass('d-none');
                    $('#date' + type + 'Static').val('');
                }
            }
        },

        /**
         * Zmena typu pole u typu Link
         *
         * @param type
         */
        typeLinkChanged: function (type) {
            DynaCore_Field.patternRemoveFields('linkDynamicTextField');
            DynaCore_Field.patternRemoveFields('linkDynamicUriField');

            $('#form-group-linkStaticDefault').addClass('d-none');
            $('#form-group-linkStaticText').addClass('d-none');
            $('#form-group-linkDynamicTextPattern').addClass('d-none');
            $('#form-group-linkDynamicUriPattern').addClass('d-none');
            $('#linkStaticDefault').val('');
            $('#linkStaticText').val('');
            $('#linkDynamicTextPattern').val('');
            $('#linkDynamicUriPattern').val('');

            if ('static' == type) {
                $('#form-group-linkStaticDefault').removeClass('d-none');
                $('#form-group-linkStaticText').removeClass('d-none');
            }
            if ('dynamic' == type) {
                $('#form-group-linkDynamicTextPattern').removeClass('d-none');
                $('#form-group-linkDynamicUriPattern').removeClass('d-none');
            }
        },

        /**
         * Zmena typu pole u typu Relation
         *
         * @param val
         */
        typeRelationExternalChanged: function (val) {
            DynaCore_Field.filtersToggle();
            DynaCore_Field.patternRemoveFields('relationField');

            $('#form-group-relationList, #form-group-relationPattern, #form-group-relationSection, #form-group-relationTarget').addClass('d-none');
            $('#relationList').val('');
            $('#relationPattern').val('');
            $('#relationSection').val('');
            $('#relationTarget').val('');

            if ('fromRelation' == val) {
                $('#form-group-relationTarget, #form-group-relationPattern').removeClass('d-none');
            }
        },

        /**
         * Zmena typu pole u typu Relation
         *
         * @param val
         */
        typeRelationTargetChanged: function (val) {
            DynaCore_Field.patternRemoveFields('relationField');

            $('#form-group-relationList, #form-group-relationSection').addClass('d-none');
            $('#relationList').val('');
            $('#relationPattern').val('');
            $('#relationSection').val('');

            if ('list' == val) {
                $('#form-group-relationList').removeClass('d-none');
            }
            if ('section' == val) {
                $('#form-group-relationSection').removeClass('d-none');
            }
        }
    }
}
